<template>
  <div class="mb-6 bg-white bg-opacity-10 backdrop-blur-sm p-6 rounded-2xl border border-white border-opacity-20 shadow-xl transform transition-all duration-300 hover:bg-opacity-15">
    <h2 class="text-2xl font-bold mb-4 text-white flex items-center">
      <span class="bg-gradient-to-r from-yellow-300 to-yellow-400 w-1.5 h-6 rounded-full mr-3"></span>
      {{title}}
    </h2>
    <ul class="space-y-4">
      <li v-for="(suggestion, index) in suggestions" :key="index" 
          class="flex items-start text-white text-opacity-90 bg-white bg-opacity-5 p-4 rounded-xl transition-all duration-300 hover:bg-opacity-10">
        <div class="flex-shrink-0 mr-3 mt-1">
          <div class="w-6 h-6 rounded-full bg-gradient-to-r from-yellow-400 to-yellow-500 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 text-blue-900" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z" />
            </svg>
          </div>
        </div>
        <div class="flex-1">
          <VueMarkdown :source="suggestion" class="suggestion-text" />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import VueMarkdown from 'vue3-markdown-it';

export default {
  components: {
    VueMarkdown
  },
  props: {
    title: { type: String, required: true },
    suggestions: { type: Array, required: true}
  }
}
</script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.suggestion-text :deep(p) {
  margin-bottom: 0.5rem;
}

.suggestion-text :deep(p:last-child) {
  margin-bottom: 0;
}

.suggestion-text :deep(code) {
  background-color: rgba(255, 255, 255, 0.15);
  padding: 0.1rem 0.3rem;
  border-radius: 0.2rem;
  font-size: 0.9em;
}
</style>